module.exports = __webpack_public_path__ + "static/media/wallpaper-5.7a67d815.jpg";